import { createFileRoute } from '@tanstack/react-router';
import { ContestsPage } from '../pages/contests/contests-page';

export const Route = createFileRoute('/contests/')({
  component: ContestsPage,
});
